<template>
  <div
    v-if="isVisible"
    class="loading-overlay"
    aria-live="polite"
    aria-busy="true"
  >
    <div class="loading-overlay__content">
      <b-spinner
        variant="primary"
        type="grow"
        class="mb-3"
        style="width: 3rem; height: 3rem;"
      ></b-spinner>
      <p v-if="messageToShow" class="text-muted mb-0">
        {{ messageToShow }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "LoadingOverlay",
  props: {
    /**
     * Controls visibility. If null, the component falls back to global loading state.
     */
    show: {
      type: Boolean,
      default: null,
    },
    /**
     * Optional custom message. If empty, a generic one is used.
     */
    message: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState("loading", {
      globalLoading: (state) => state.loading,
    }),
    isVisible() {
      // If component is controlled via prop, use it.
      if (this.show !== null) {
        return this.show;
      }
      // Otherwise fall back to global loading state.
      return this.globalLoading;
    },
    messageToShow() {
      if (this.message) {
        return this.message;
      }
      return this.globalLoading ? "Cargando..." : "";
    },
  },
};
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 0.25rem;
}

.loading-overlay__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>

